export const SHELL_STATES = {
  gateway: 'gateway',
  nonGateway: 'non-gateway'
};
